(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    const data = root.querySelector('[data-ipc-data]');
    if (!data) return;
    let jackets;
    try { jackets = JSON.parse(data.content.textContent).jackets; } catch (e) { return; }
    root.dataset.ready = 'true';
    const $ = s => root.querySelector(s);
    let selected = null, lining = null, values = [], finishes = {}, busy = false;
    const text = (tag, value) => { const el = document.createElement(tag); el.textContent = value; return el; };
    const variant = () => selected && selected.variants.find(v => v.options.every((o, i) => o === values[i]));
    function properties() {
      const p = { 'Jacket': selected.name, 'Lining collection': selected.collection, 'Lining colourway': lining.name, 'Lining material': 'Satin viscose' };
      (selected.options || []).forEach((name, i) => { if (name !== 'Title') p[name] = values[i]; });
      Object.keys(finishes).forEach(k => { p[k] = finishes[k]; });
      return p;
    }
    function update() {
      const v = variant();
      $('[data-summary-title]').textContent = selected.name;
      const dl = $('[data-summary]'); dl.replaceChildren();
      const p = lining ? properties() : { Jacket: selected.name, Lining: 'Please contact us for available linings' };
      Object.entries(p).forEach(([k, val]) => { const row = document.createElement('div'); row.append(text('dt', k), text('dd', val)); dl.append(row); });
      $('[data-composition]').value = Object.entries(p).map(([k, val]) => k + ': ' + val).join('\n');
      $('[data-price]').textContent = selected.ordering && v ? v.price : '';
      const canBuy = selected.ordering && v && v.available && lining;
      $('[data-add]').hidden = !canBuy;
      $('[data-availability]').textContent = !selected.ordering ? 'Discuss your composition with ISEPP.' : !v ? 'This combination is unavailable. Please select another option or enquire.' : !v.available ? 'Currently unavailable to order online. Please enquire.' : !lining ? 'Please enquire about lining availability.' : 'Your selected lining and finishes will be included in your order details.';
      $('[data-error]').textContent = '';
    }
    function chooseLining(item) {
      lining = item;
      $('[data-lining-image]').src = item.image;
      $('[data-lining-image]').alt = selected.collection + ' — ' + item.name;
      $('[data-lining-image]').hidden = false;
      $('[data-lining-caption]').textContent = item.name + ' / ' + selected.collection;
      $('[data-swatches]').querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.colour === item.name)));
      update();
    }
    function selector(label, opts, parent, change, index) {
      const id = 'ipc-' + root.id + '-' + index;
      const lab = text('label', label); lab.htmlFor = id;
      const select = document.createElement('select'); select.id = id;
      opts.forEach(value => { const o = text('option', value); o.value = value; select.append(o); });
      select.addEventListener('change', () => { change(select.value); update(); });
      parent.append(lab, select);
      return select;
    }
    function chooseJacket(id, scroll) {
      if (busy) return;
      selected = jackets.find(j => j.id === id); if (!selected) return;
      $('[data-composer]').hidden = false;
      root.querySelectorAll('[data-jacket]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.jacket === id)));
      $('[data-collection]').textContent = selected.collection;
      $('[data-story]').textContent = selected.story;
      $('[data-options]').replaceChildren(); $('[data-finishes]').replaceChildren();
      values = (selected.variants.find(v => v.available) || selected.variants[0] || {options:[]}).options.slice();
      (selected.options || []).forEach((name, i) => {
        if (name === 'Title' && values[i] === 'Default Title') return;
        const choices = [...new Set(selected.variants.map(v => v.options[i]))];
        const el = selector(name, choices, $('[data-options]'), val => { values[i] = val; }, 'variant-'+i);
        el.value = values[i];
      });
      if (!selected.variants.length) $('[data-options]').append(text('p', 'Sizing and leather will be discussed during your personal consultation.'));
      finishes = {};
      [['Zip finish',selected.zip],['Hardware finish',selected.hardware]].forEach(([name, csv], i) => {
        const opts = csv.split(',').map(s => s.trim()).filter(Boolean);
        if (!opts.length) return;
        finishes[name] = opts[0]; selector(name, opts, $('[data-finishes]'), val => { finishes[name] = val; }, 'finish-'+i);
      });
      const swatches = $('[data-swatches]'); swatches.replaceChildren(); lining = null;
      const available = selected.linings.filter(l => l.enabled);
      available.forEach(item => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'ipc-swatch'; button.dataset.colour = item.name; button.setAttribute('aria-pressed', 'false');
        const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.loading = 'lazy';
        button.append(img, text('span', item.name)); button.addEventListener('click', () => { if (!busy) chooseLining(item); }); swatches.append(button);
      });
      if (available.length) chooseLining(available[0]);
      else { $('[data-lining-image]').hidden = true; $('[data-lining-caption]').textContent = 'Please enquire for available colourways.'; update(); }
      if (scroll) { $('[data-collection]').tabIndex = -1; $('[data-collection]').focus({preventScroll:true}); $('#ipc-lining').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}); }
    }
    root.querySelectorAll('[data-jacket]').forEach(b => b.addEventListener('click', () => chooseJacket(b.dataset.jacket, true)));
    $('[data-add]').addEventListener('click', async () => {
      const v = variant(); if (busy || !selected.ordering || !v || !v.available || !lining) return;
      busy = true;
      const btn = $('[data-add]'); btn.textContent = 'Adding to bag…'; btn.disabled = true;
      const controls = [...root.querySelectorAll('[data-jacket], .ipc-swatch, select')]; controls.forEach(c => c.disabled = true);
      try {
        const response = await fetch(root.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties:properties()}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This jacket could not be added. Please check availability or contact ISEPP.');
        window.location.assign(root.dataset.cartUrl);
      } catch (e) {
        $('[data-error]').textContent = e.message || 'Unable to connect. Please check your bag before trying again.';
        busy = false; btn.disabled = false; btn.textContent = 'Add to bag'; controls.forEach(c => c.disabled = false);
      }
    });
    const params = new URLSearchParams(window.location.search);
    const initial = jackets.find(j => j.name.toLowerCase() === (params.get('jacket') || '').toLowerCase());
    if (initial) chooseJacket(initial.id, false);
  }
  function scan(node) { if (node.matches && node.matches('[data-ipc]')) init(node); node.querySelectorAll('[data-ipc]').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
})();
